var _linearGradient, _linearGradient2, _linearGradient3, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCypress1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "6.5 6.4 950.0999999999999 948.5",
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 2496,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 992.991,
    x2: 568.87,
    y1: 483.702,
    y2: 758.304
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.081,
    stopColor: "#69d3a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69d3a7",
    stopOpacity: 0
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 323.384,
    x2: 56.936,
    y1: 12.396,
    y2: 577.503
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#69d3a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    stopColor: "#2ab586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1cae7f"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 5.828,
    x2: 704.494,
    y1: 697.848,
    y2: 917.116
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.077,
    stopColor: "#1cae7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164,
    stopColor: "#1ca379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#1c8568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    stopColor: "#1b554d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#1b1e2e"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M340.4 382.8c38.4 0 69.6 20.5 85.6 56.1l1.2 2.8 64.4-21.9-1.3-3.3c-24.9-60.8-82.4-98.5-149.9-98.5-47.5 0-86.1 15.2-118 46.5-31.7 31.1-47.7 70.2-47.7 116.2 0 45.7 16.1 84.6 47.7 115.6 31.9 31.3 70.5 46.5 118 46.5 67.5 0 124.9-37.8 149.9-98.5l1.3-3.3-64.5-21.9-1.1 2.9c-14.4 35.1-46.4 56-85.6 56-26.7 0-49.3-9.3-67.1-27.7-18.1-18.6-27.2-42.1-27.2-69.6 0-27.7 8.9-50.7 27.2-70.2 17.9-18.4 40.4-27.7 67.1-27.7z",
    fill: "#1b1e2e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M620 934.4l-19.2-63.3C774 818.5 890.4 661.6 890.4 480.7c0-49.9-8.9-98.7-26.5-144.9l61.8-23.5c20.5 53.8 30.9 110.4 30.9 168.5-.1 210.1-135.3 392.4-336.6 453.6z",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M872.5 361.1c-52.9-172.6-210-288.5-391-288.5-24.6 0-49.2 2.2-73.2 6.5L396.6 14c27.8-5 56.4-7.6 84.9-7.6 210.2 0 392.7 134.7 454.2 335.2z",
    fill: "#69d3a7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9 647.9C16.7 594.5 6.5 538.2 6.5 480.7c0-245 183.9-447.9 427.8-471.9l6.5 65.8C230.9 95.3 72.6 269.9 72.6 480.7c0 49.5 8.8 98 26.1 143.9z",
    fill: "url(#b)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M743.7 324L652 556.4 559.6 324H484l129.6 317.2-94.4 229 66.1 13.2L815.1 324z",
    fill: "#1b1e2e"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M531.1 841.4l-13.9 33.7c-3.2 7.7-10.5 13-18.7 13.3-5.7.2-11.3.4-17.1.4-181.5 0-343.1-121.5-393-295.5l-63.6 18.2c58 202.1 245.7 343.3 456.5 343.4h.1c6.6 0 13.2-.1 19.8-.4 33.9-1.4 64.2-22.7 77.2-54.2l18.8-45.7z",
    fill: "url(#c)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCypress1);
export default __webpack_public_path__ + "static/media/cypress-1.51fd3dd5999d49991d91b690a55e9d14.svg";
export { ForwardRef as ReactComponent };